import { useState, useCallback } from 'react';

/**
Hook per la gestione dello stato di una form, @see `Form`.
@param initState stato iniziale
@returns array con stato [0] e funzione di onChange [1]
 */
function useFormState(initState) {
    const [state, setState] = useState(initState);
    const onChange = useCallback((partialState) => {
        setState((s) => (Object.assign(Object.assign({}, s), partialState)));
    }, []);
    return [state, onChange];
}

export { useFormState as default };
